import { atom } from 'recoil';

export const userState = atom({
  key: 'userState', // unique ID (with respect to other atoms/selectors)
  default: { userId: null, useremail:null, token: null }, // default value (aka initial value)
});

export const userRegistererState = atom({key: 'userRegistererState', 
 default: {}, 
});